import {Component, Input} from '@angular/core';
import {CommonMessagesService} from '../../../services/common-messages.service';

@Component({
  selector: 'app-clipboard-label',
  templateUrl: './clipboard-label.component.html',
  styleUrls: ['./clipboard-label.component.scss']
})
export class ClipboardLabelComponent {

  @Input() value: string;
  @Input() copiedValue: string;
  @Input() showIcon: boolean = true;


  constructor(public commonMessagesService: CommonMessagesService) {
  }

}
